import React from "react";
import PropTypes from "prop-types";

import { css } from "react-emotion";
import PulseLoader from "react-spinners/PulseLoader";

const loadingStyle = css`
  display: inline;
  margin-left: 4px;
`;

const LoadingButtonIcon = ({ loading }) => (
  <PulseLoader
    loading={loading}
    size={4}
    color="white"
    className={loadingStyle}
  />
);

LoadingButtonIcon.propTypes = {
  loading: PropTypes.bool.isRequired,
};

export default LoadingButtonIcon;
